import { call, takeEvery, select } from 'redux-saga/effects';
import {
  ADD_ACTOR_ATTACHES,
  REMOVE_ACTOR_ATTACHES,
} from '@control-front-end/common/constants/graphActors';
import {
  makeAttach,
  bindAttach,
  unBindAttach,
} from '@control-front-end/common/sagas/attachUtils';
import { updateActorView } from './actorView';

/**
 * Прикрепить вложение к актору
 */
function* addActorAttachments({ payload, callback }) {
  const { actorId, files } = payload;
  // создание аттачей
  const attachments = yield call(makeAttach, files);
  // привязка аттачей
  yield call(bindAttach, attachments, actorId);
  // Обновить модель актора
  const actorView = yield select((state) => state.actorView);
  if (actorView.id !== actorId) return;
  const actor = { ...actorView };
  const newAttachments = actor.attachments ? actor.attachments.slice() : [];
  newAttachments.unshift(...attachments);
  yield call(updateActorView, {
    payload: { actorData: { ...actor, attachments: newAttachments } },
  });
  if (callback) callback(attachments);
}

/**
 * Открепить вложение от актора
 */
function* deleteActorAttachments({ payload }) {
  const { actorId, files } = payload;
  const filesToDelete = Array.isArray(files) ? files : [files];
  // удаление аттачей
  if (filesToDelete.length) {
    yield call(unBindAttach, filesToDelete, actorId);
  }
  // Обновить модель актора
  const actorView = yield select((state) => state.actorView);
  if (actorView.id !== actorId) return;
  if (actorView.attachments && actorView.attachments.length) {
    const updAttachments = actorView.attachments.filter(
      (i) => !filesToDelete.find((u) => u.id === i.id)
    );
    yield call(updateActorView, {
      payload: {
        actorData: {
          ...actorView,
          attachments: updAttachments,
        },
      },
    });
  }
}

function* actorsAttaches() {
  yield takeEvery(ADD_ACTOR_ATTACHES.REQUEST, addActorAttachments);
  yield takeEvery(REMOVE_ACTOR_ATTACHES.REQUEST, deleteActorAttachments);
}

export default actorsAttaches;
